import React from 'react'
import Pagination from '../../common/pagination/Pagination'

const GroupDashboardCardFooter = ( props ) => {

  const table = props.data ?? ''
  const pageSize = props.pageSize ?? ''
  const rows = table.getFilteredRowModel().rows.length ?? 0
  const hasPagination = pageSize ? rows > pageSize[0] ? true : false : true

  return (
    <>
    {
      hasPagination &&
        <div className="msync-table__footer">
          <Pagination
            table={ table }
            pageSize={ pageSize }
          />
        </div>
    }
    </>
  )
}

export default GroupDashboardCardFooter
